import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AuthProviderEnum} from "../enum/auth-provider-enum";

@Component({
  selector: 'fb-auth-social-method',
  templateUrl: './auth-social-method.component.html',
  styleUrls: ['./auth-social-method.component.scss']
})
export class AuthSocialMethodComponent {

	@Input()
	public aProvider: AuthProviderEnum = AuthProviderEnum.UNKNOWN;
	@Output()
	public authProvider: EventEmitter<AuthProviderEnum> = new EventEmitter<AuthProviderEnum>();
	protected readonly AuthProviderEnum = AuthProviderEnum;
}
